import classNames from 'classnames';
import { ReactNode } from 'react';
import { FormattedMessage, type IntlShape } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import logError from '@alltrails/core/utils/logError';
import Access from '@alltrails/filters/constants/accessEnum';
import type { TrailDifficulty } from '@alltrails/trails';
import type TrailFeature from '@alltrails/types/TrailFeature';
import labels from './labels';
import styles from './Tags.module.scss';
import { SectionType } from './types';

type TagSectionProps = {
  heading: ReactNode;
  children: ReactNode;
  shouldHideTitle?: boolean;
};

const TagsSection = ({ heading, children, shouldHideTitle }: TagSectionProps) => (
  <div className={styles.column}>
    <Typography className={classNames(styles.title, shouldHideTitle && styles.hiddenTitle)} component="h3" variant="heading200">
      {heading}
    </Typography>
    {children}
  </div>
);

function getFeatureOrAccessLabel(intl: IntlShape, tag: TrailFeature | Access | TrailDifficulty) {
  const message = labels[tag];
  if (!message) {
    logError(new Error(`missing message for tag ${tag}`));
  }
  return message ? intl.formatMessage(message) : null;
}

const typeToLabel: Record<SectionType, ReactNode> = {
  activity: <FormattedMessage defaultMessage="Activities" />,
  attraction: <FormattedMessage defaultMessage="Attractions" />,
  suitability: <FormattedMessage defaultMessage="Suitability" />,
  poi: <FormattedMessage defaultMessage="Points of interest" />
};

export { TagsSection, getFeatureOrAccessLabel, typeToLabel };
